import { CondenserType, ConfigurationType, ZoneType } from 'data/types';
import { isDuctedOnlyPreference } from 'utils/project';

export function defaultConfigurationType(
  fallback: ConfigurationType['type']
): ConfigurationType['type'] {
  return isDuctedOnlyPreference() ? 'ducted' : fallback;
}

export function defaultCondenserType(): CondenserType['type'] {
  return isDuctedOnlyPreference() ? 'ducted' : 'ductless';
}

function withPathwayType(configuration: ConfigurationType): ConfigurationType {
  const type = defaultConfigurationType(configuration.type);
  return type === configuration.type
    ? configuration
    : { ...configuration, type };
}

export function typeEmptyConfigurationsForPathway(
  configurations: ConfigurationType[]
): ConfigurationType[] {
  return configurations.map((configuration) =>
    configuration.condensers.length === 0
      ? withPathwayType(configuration)
      : configuration
  );
}

export function defaultZoneTypeForCondenser(
  condenser: Pick<CondenserType, 'type'>
): ZoneType['type'] {
  return condenser.type === 'ducted' ? 'ducted' : 'ductless';
}
